<template>
  <div class="switch-box">
    <template v-for="(item, index) in tabList">
      <div
        :key="item.value"
        class="btn"
        :class="{ active: index === currentIndex }"
        @click="tabItemClick({ item, index })"
      >
        {{ item.label }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabList: [
        { label: "登录", value: "login" },
        { label: "注册", value: "register" },
      ],
      currentIndex: 0,
    };
  },
  watch: {
    current: {
      handler(newVal) {
        const item = this.tabList[newVal];
        const index = newVal;
        this.tabItemClick({ item, index });
      },
    },
  },
  methods: {
    tabItemClick({ item, index }) {
      this.currentIndex = index;
      this.$emit("click", { item, index });
    },
  },
};
</script>

<style scoped lang="scss">
.switch-box {
  position: absolute;
  right: -10px;
  bottom: 19%;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 145px;
  height: 64px;
  border-radius: 12px;
  font-size: 27px;
  color: #fff;
  cursor: pointer;
}

.active {
  background: #ffffff;
  color: #A40000;
  font-weight: 500;
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .btn {
    width: 120px;
    height: 54px;
    font-size: 22px;
    border-radius: 10px;
  }

  .switch-box {
    right: -8px;
    bottom: 18%;
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .switch-box {
    position: absolute;
    right: auto;
    left: 50%;
    bottom: 22px;
    
    transform: translate(-50%, 50%);
    display: flex;
    flex-direction: row;
    gap: 12px;
    z-index: 2;
  }

  .btn {
    width: 100px;
    height: 44px;
    font-size: 18px;
    border-radius: 22px 22px 0 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}

/* 小屏手机适配 */
@media screen and (max-width: 480px) {
  .switch-box {
    gap: 8px;
    bottom: 18px;
  }

  .btn {
    width: 86px;
    height: 38px;
    font-size: 16px;
    border-radius: 19px 19px 0 0;
  }
}
</style>
